/**
 * Enumeration of coordinate formats.
 *
 * @readonly
 * @enum {string}
 */
export const CoordinateFormats = Object.freeze({
    DD: 'DD',
    DMS: 'DMS'
})
